function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSentry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Strokes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: -0.01,
    width: 16,
    height: 16,
    style: {
      fill: "#b82abe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.74,12.63c.2-.35.2-.77,0-1.12L8.94,2.95c-.2-.35-.55-.56-.94-.56s-.75.21-.94.56l-1.55,2.76.39.23c1.15.68,2.11,1.67,2.78,2.86.59,1.05.94,2.24,1.01,3.44h-1.09c-.07-1.01-.36-2-.86-2.88-.57-1.02-1.4-1.87-2.38-2.45l-.39-.23-1.45,2.59.39.23c.96.57,1.64,1.62,1.78,2.75h-2.49c-.09,0-.14-.06-.16-.09-.02-.03-.05-.1,0-.18l.69-1.24c-.24-.21-.5-.36-.79-.46l-.69,1.23c-.2.35-.2.77,0,1.12.2.35.55.56.94.56h3.42v-.47c0-.81-.21-1.62-.61-2.33-.32-.57-.76-1.07-1.27-1.45l.54-.97c.68.48,1.25,1.12,1.67,1.86.49.88.75,1.88.75,2.88v.47s2.9,0,2.9,0v-.47c0-1.53-.39-3.04-1.14-4.38-.67-1.2-1.61-2.21-2.72-2.96l1.1-1.97c.04-.08.12-.09.16-.09s.11.01.16.09l4.8,8.56c.05.08.02.15,0,.18-.02.03-.07.09-.16.09h-1.13c.01.31.02.62,0,.93h1.13c.39,0,.75-.21.94-.56",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSentry);
export default __webpack_public_path__ + "static/media/logo-sentry.3131bcdd6f8a94523a625f1d481ce337.svg";
export { ForwardRef as ReactComponent };